import $api from "../Api";
import Endpoints from "../Endpoints";

/**
 * HTTP 200 içinde isSuccess false / NOT_FOUND gelebilir.
 * GET bilgi çağrısında toast açılmaması için ResponseChecker kullanılmaz.
 * @param {object} response
 * @returns {{ isSuccess: boolean, message: string, data: object|null, exceptionMessage?: string|null }}
 */
const normalizeResult = (response) => {
  if (response?.result !== "OK") {
    return {
      ...response,
      message: response?.message || "FAIL",
      isSuccess: false,
      data: response?.data ?? null,
      exceptionMessage: response?.exceptionMessage || null,
    };
  }

  return {
    ...response,
    message: response.message || "FAIL",
    isSuccess: response.isSuccess === true || response.message === "OK",
    data: response.data ?? null,
    exceptionMessage: response.exceptionMessage || null,
  };
};

/**
 * İlk CompanySettings kaydının abonelik remote ID'sini günceller.
 * Yalnızca remoteId gönderilir; e-posta bu endpoint ile güncellenmez.
 * @param {{ remoteId: string }} form
 */
export const SubscriptionRegister = async (form) => {
  const response = await $api.post(
    Endpoints.Subscription.SubscriptionRegister(),
    {
      remoteId: form?.remoteId,
      email: form?.email,
    }
  );
  return normalizeResult(response);
};

/**
 * İlk CompanySettings kaydındaki abonelik bağlantı bilgilerini getirir.
 * @param {{ query?: object, params?: object }} [option]
 */
export const GetSubscriptionInfo = async (option) => {
  const response = await $api.get(
    Endpoints.Subscription.GetSubscriptionInfo(option)
  );
  return normalizeResult(response);
};

export default {
  SubscriptionRegister,
  GetSubscriptionInfo,
};
